/* Carousel styles*/
:host {
  position: relative;
  display: flex;
}

.slim-slider-wrapper {
  overflow: hidden;
  text-align: center;
  height: 100%;
  min-width: 100%;
}

.slim-slider-wrapper > div, .slim-slider-wrapper > img, .slim-slider-wrapper > p {
  width: 100%;
  height: 100%;
  display: flex;
}

.slim-slider-wrapper > div.vertical, .slim-slider-wrapper > img.vertical, .slim-slider-wrapper > p.vertical {
  flex-direction: column;
}

.slim-slider-wrapper > div.is-animating, .slim-slider-wrapper > img.is-animating, .slim-slider-wrapper > p.is-animating {
  transition: transform 400ms;
}

.carousel-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: -36px;
  width: 100%;
  height: 35px;
  z-index: 100;
}

:host(:not([dir="rtl"])) .carousel-pagination {
  left: 0;
}

:host([dir="rtl"]) .carousel-pagination {
  right: 0;
}

.carousel-pagination a {
  width: 7px;
  height: 7px;
  padding: 0;
  margin: 0 3px;
  border-radius: 50%;
  background: #cbcbcb;
  border: 0;
  outline: none;
  cursor: pointer;
}

.carousel-pagination a.pointer {
  cursor: none;
}

.carousel-pagination a:first-child, .carousel-pagination a:last-child {
  width: 12px;
  height: 12px;
}

.carousel-pagination a.active {
  background: #3dcd58;
}

.carousel-pagination .carousel-pagination__above {
  bottom: 85px;
}

.small-point a {
  width: 6px;
  height: 6px;
}

.small-point a:first-child, .small-point a:last-child {
  width: 4px;
  height: 4px;
}

.small-point a.active {
  width: 6px;
  height: 6px;
}

.carousel-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 50%;
  width: 100%;
  height: 0;
  z-index: 100;
}

:host(:not([dir="rtl"])) .carousel-buttons {
  left: 0;
}

:host([dir="rtl"]) .carousel-buttons {
  right: 0;
}

.carousel-buttons.vertical {
  bottom: 0;
  width: 0;
  height: 100%;
  z-index: 100;
}

:host(:not([dir="rtl"])) .carousel-buttons.vertical {
  left: 28px;
}

:host([dir="rtl"]) .carousel-buttons.vertical {
  right: 28px;
}

.carousel-buttons.vertical button {
  background: none;
  border: none;
  padding: 0;
  outline: inherit;
  cursor: pointer;
  position: absolute;
  -webkit-user-select: none;
          user-select: none;
  text-decoration: none;
  color: rgba(51, 51, 51, 0.5);
}

.carousel-buttons.vertical button.next, .carousel-buttons.vertical button.prev {
  cursor: pointer;
}

:host(:not([dir="rtl"])) .carousel-buttons.vertical button.next, :host(:not([dir="rtl"])) .carousel-buttons.vertical button.prev {
  left: -20px;
}

:host([dir="rtl"]) .carousel-buttons.vertical button.next, :host([dir="rtl"]) .carousel-buttons.vertical button.prev {
  right: -20px;
}

.carousel-buttons.vertical button.next.disabled, .carousel-buttons.vertical button.prev.disabled {
  color: rgba(51, 51, 51, 0.3);
}

.carousel-buttons.vertical button.prev {
  top: -35px;
}

.carousel-buttons.vertical button.next {
  bottom: -27px;
}

.carousel-buttons:not(.vertical) button {
  background: none;
  border: none;
  padding: 0;
  outline: inherit;
  cursor: pointer;
  font-size: 22px;
  position: absolute;
  -webkit-user-select: none;
          user-select: none;
  text-decoration: none;
}

.carousel-buttons:not(.vertical) button.next, .carousel-buttons:not(.vertical) button.prev {
  cursor: pointer;
}

.carousel-buttons:not(.vertical) button.next.disabled, .carousel-buttons:not(.vertical) button.prev.disabled {
  color: rgba(51, 51, 51, 0.3);
}

.carousel-buttons:not(.vertical) button.next {
  font-size: 56px;
  color: #626469;
}

:host(:not([dir="rtl"])) .carousel-buttons:not(.vertical) button.next {
  right: -40px;
}

:host([dir="rtl"]) .carousel-buttons:not(.vertical) button.next {
  left: -40px;
}

.carousel-buttons:not(.vertical) button.prev {
  font-size: 56px;
  color: #626469;
}

:host(:not([dir="rtl"])) .carousel-buttons:not(.vertical) button.prev {
  left: -50px;
}

:host([dir="rtl"]) .carousel-buttons:not(.vertical) button.prev {
  right: -50px;
}

.small-card a {
  flex-flow: row-reverse;
}